import React from "react";
import "./Newmonard.scss";
import Comingsoon from "../../../Media/Monard_Desktop.webp";
import Soon from "../../../Media/Monard_Mobile.webp";

const handleConsultationClick = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=6282122005507&text=Halo%20Dean,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20BSD%20City%20(New%20Launching%20Monard)%20https://bsdcity-marketing.id//&type=phone_number&app_absent=0";
  window.open(whatsappLink, "_blank");
};

const soon = () => {
  return (
    <div id="vireya" className="container-soon">
      <div className="louise">
        <h1>New Launching BSD City</h1>
        <h1>Monard at Armont Residence</h1>
      </div>
      <div className="maps-lokasi">
        <img
          id="location"
          className="img-lokasi-dekstop"
          src={Comingsoon}
          alt="maps"
        />
        <img id="lokasi" className="img-lokasi-mobile" src={Soon} alt="maps" />
      </div>
      <div className="button">
        <div className="container-wa">
          <button className="buttonpenawaran" onClick={handleConsultationClick}>
            More Info
          </button>
        </div>
      </div>
    </div>
  );
};

export default soon;
